import { createSlice } from '@reduxjs/toolkit';
import { loginUser } from './thunks/loginUser';

const authReducer = createSlice({
  name: 'auth',
  initialState: {
    sessionId: null,
    user: null,
    loading: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.sessionId = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.user = action.payload;
        state.sessionId = action.payload.sessionId;
        state.loading = false;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  }
});

export const { logout } = authReducer.actions;
export default authReducer.reducer;
